import { render, staticRenderFns } from "./LocationDetail.vue?vue&type=template&id=0fbec714&scoped=true"
import script from "./LocationDetail.vue?vue&type=script&lang=js"
export * from "./LocationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbec714",
  null
  
)

export default component.exports